import { DEFAULT_ONLINE_BAG_FILTERS, DEFAULT_SORT } from 'constants/index';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  onlineBagData: {
    items: [],
    total: null,
  },
  foundOnlineBags: {
    items: [],
    total: null,
  },
  loading: false,
  error: null,
  onlineBagFilters: DEFAULT_ONLINE_BAG_FILTERS,
  selectedOnlineBagSort: DEFAULT_SORT,
  onlineBagCountOfNewClientForNotification: 0,
};

const clientOnlineBagTab = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.CLIENT_GET_ONLINE_BAG_TAB_LOADING:
    case actionTypes.CLIENT_SEARCH_ONLINE_BAG_TAB_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.CLIENT_GET_ONLINE_BAG_TAB_SUCCESS:
      return {
        ...state,
        loading: false,
        onlineBagData: {
          items: [...state.onlineBagData.items, ...payload.items],
          total: payload.total,
        },
      };
    case actionTypes.CLIENT_GET_ONLINE_BAG_TAB_ERROR:
    case actionTypes.CLIENT_SEARCH_ONLINE_BAG_TAB_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.CLIENT_GET_ONLINE_BAG_TAB_CLEAR:
      return {
        ...state,
        onlineBagData: { ...INITIAL_STATE.onlineBagData },
        loading: INITIAL_STATE.loading,
        error: INITIAL_STATE.error,
      };
    case actionTypes.CLIENT_SEARCH_ONLINE_BAG_TAB_SUCCESS:
      return {
        ...state,
        loading: false,
        foundOnlineBags: {
          items: [...state.foundOnlineBags.items, ...payload?.items],
          total: payload.total,
        },
      };
    case actionTypes.CLIENT_SEARCH_ONLINE_BAG_TAB_CLEAR:
      return {
        ...state,
        foundOnlineBags: { ...INITIAL_STATE.foundOnlineBags },
        loading: INITIAL_STATE.loading,
        error: INITIAL_STATE.error,
      };
    case actionTypes.CLIENT_SET_ONLINE_BAG_FILTERS_SELECTION:
      return {
        ...state,
        onlineBagFilters: payload,
      };
    case actionTypes.CLIENT_SET_ONLINE_BAG_SORT_SELECTION:
      return {
        ...state,
        selectedOnlineBagSort: payload,
      };
    case actionTypes.CLIENT_SET_NEW_COUNT_FOR_ONLINE_BAG_NOTIFICATION:
      return {
        ...state,
        onlineBagCountOfNewClientForNotification: payload,
      };
    default:
      return state;
  }
};

export default clientOnlineBagTab;
